
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

let timeOutChangePrice = null;

export default {
  name: 'SectionPrice',

  data: function () {
    const currencyMask = function (rawValue) {
      const numberMask = createNumberMask({
        prefix: '',
        allowDecimal: true,
        allowNegative: true,
        decimalSymbol: '.',
        thousandsSeparatorSymbol: ' ',
        decimalLimit: 2,
      });
      rawValue = rawValue.replace(',', '.');
      const mask = numberMask(rawValue);
      return mask;
    };

    return {
      priceFrom: '',
      priceTo: '',

      isOpen: true,

      currencyMask: currencyMask,
    };
  },

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    filtersSelected: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    minPrice: function () {
      return this.data?.minPrice || 0;
    },
    maxPrice: function () {
      return this.data?.maxPrice || 999999;
    },
  },

  watch: {
    filtersSelected: function () {
      const priceFrom = Object.keys(this.filtersSelected?.priceFrom || {})?.[0] || '';
      const priceTo = Object.keys(this.filtersSelected?.priceTo || {})?.[0] || '';
      if (priceFrom !== String(parseInt((this.priceFrom || '').replace(/[^\d]/g, '')) || '')) {
        this.priceFrom = priceFrom;
      }
      if (priceTo !== String(parseInt((this.priceTo || '').replace(/[^\d]/g, '')) || '')) {
        this.priceTo = priceTo;
      }
    },

    priceTo: function () {
      clearTimeout(timeOutChangePrice);
      timeOutChangePrice = setTimeout(() => {
        this.changeFilter();
      }, 600);
    },
    priceFrom: function () {
      clearTimeout(timeOutChangePrice);
      timeOutChangePrice = setTimeout(() => {
        this.changeFilter();
      }, 600);
    },
  },

  mounted: function () {
    const priceFrom = Object.keys(this.filtersSelected?.priceFrom || {})?.[0] || '';
    const priceTo = Object.keys(this.filtersSelected?.priceTo || {})?.[0] || '';
    if (priceFrom) {
      this.priceFrom = priceFrom;
    }
    if (priceTo) {
      this.priceTo = priceTo;
    }
  },

  methods: {
    changeOpen: function () {
      this.isOpen = !this.isOpen;
    },
    changeFilter: function () {
      const filtersSelected = { ...this.filtersSelected };

      const priceFrom = parseInt(String(this.priceFrom || '').replace(/[^\d]/g, '')) || '';
      if (priceFrom) {
        filtersSelected.priceFrom = {
          [priceFrom]: priceFrom,
        };
      }

      const priceTo = parseInt(String(this.priceTo || '').replace(/[^\d]/g, '')) || '';
      if (priceTo) {
        filtersSelected.priceTo = {
          [priceTo]: priceTo,
        };
      }

      this.$emit('change', filtersSelected);
    },
    resetPrice: function (name) {
      this[name] = '';
      this.changeFilter();
    },
  },
};
